/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { Lock, ShieldCheck, Loader2, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ProprietaryWatermark } from '@/components/security/ProprietaryWatermark';

/** Schermata di accesso al wizard (password di setup). */
export const SetupGate = ({ status, password, onPasswordChange, onSubmit, busy, onBack }) => (
  <div className="min-h-screen bg-background flex items-center justify-center p-4 relative isolate" data-testid="setup-gate">
    <ProprietaryWatermark />
    <Card className="w-full max-w-md rounded-xl">
      <CardContent className="p-6 space-y-5">
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 rounded-xl bg-primary text-primary-foreground flex items-center justify-center"><Lock className="h-6 w-6" /></div>
          <div>
            <h1 className="font-display font-bold text-xl">Installer Wizard</h1>
            <p className="text-xs text-muted-foreground">Configurazione iniziale riservata all'amministratore IT.</p>
          </div>
        </div>
        {status && !status.password_configured && status.has_admin && (
          <div className="rounded-xl border border-warning/50 bg-warning/10 p-3 text-xs flex gap-2"><AlertTriangle className="h-4 w-4 text-warning flex-shrink-0" /> Imposta <span className="font-mono">SETUP_PASSWORD</span> nel .env del backend per abilitare il wizard.</div>
        )}
        {status && !status.password_configured && !status.has_admin && (
          <div className="rounded-xl border border-primary/30 bg-primary/5 p-3 text-xs">Prima installazione rilevata: nessuna password richiesta. Premi Accedi.</div>
        )}
        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <Label>Password di setup</Label>
            <Input type="password" value={password} onChange={(e) => onPasswordChange(e.target.value)} className="h-11 rounded-xl" autoFocus data-testid="setup-password" />
          </div>
          <Button type="submit" disabled={busy || (status?.password_configured && !password)} className="w-full h-11 rounded-xl" data-testid="setup-login-btn">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShieldCheck className="h-4 w-4" />} Accedi al wizard
          </Button>
        </form>
        <div className="text-[11px] text-muted-foreground flex items-center justify-between">
          <span>DB: <b>{status?.db_kind || '…'}</b> · modalità <b>{status?.app_mode || '…'}</b></span>
          <button type="button" className="underline" onClick={onBack}>Torna all'app</button>
        </div>
      </CardContent>
    </Card>
  </div>
);
